import React from 'react';

const MissionsTab = () => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Missions</h5>
        <button className="btn btn-primary btn-sm" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
          + Create Mission
        </button>
      </div>

      <table className="table table-hover">
        <thead>
          <tr>
            <th>Mission Name</th>
            <th>Frequency</th>
            <th>Reward Points</th>
            <th>Action Type</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="6" className="text-center text-muted py-5">
              Missions will be available in a future update.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MissionsTab;
